import { reachOf, areasOf } from '@utils/stationScope';

const TONES = {
  green: { background: 'rgba(74,174,73,0.14)', border: '1px solid rgba(74,174,73,0.5)', color: '#4AAE49' },
  blue:  { background: 'rgba(90,166,224,0.12)', border: '1px solid rgba(90,166,224,0.5)', color: '#5AA6E0' },
  amber: { background: 'rgba(232,160,0,0.12)', border: '1px solid rgba(232,160,0,0.6)', color: '#E8A000' },
  code:  { background: '#0b0b0b', border: '1px solid rgba(245,200,0,0.5)', color: '#F5C800' },
};

function Chip({ tone, children }) {
  return (
    <span className="text-2xs font-mono px-1.5 py-0.5 rounded" style={TONES[tone]}>{children}</span>
  );
}

/** A user's station access as chips: All stations, Station not set, or Regional + codes. */
export function StationChips({ user }) {
  const reach = reachOf(user);
  if (reach === 'all') return <Chip tone="green">All stations</Chip>;
  if (reach.length === 0) return <Chip tone="amber">Station not set</Chip>;
  return (
    <>
      {reach.length > 1 && <Chip tone="blue">Regional</Chip>}
      {reach.map((c) => <Chip key={c} tone="code">{c}</Chip>)}
    </>
  );
}

/** A user's departments as chips: BOH, FOH, or both. */
export function AreaChips({ user }) {
  return (
    <>
      {areasOf(user).map((a) => <Chip key={a} tone={a === 'BOH' ? 'blue' : 'green'}>{a}</Chip>)}
    </>
  );
}
